import "./Notes.css";

export default function Notes() {
  return (
    <div className="notes-page">

      <h1 className="notes-title">✨ Learning Notes ✨</h1>

      <div className="notes-glass">

        {/* LEFT SIDEBAR */}
        <div className="notes-sidebar">
          <button className="side-btn active">📘 Lesson</button>
          <button className="side-btn">📝 Quiz</button>
          <button className="side-btn">📂 Resources</button>
          <button className="side-btn">🎯 Goals</button>
        </div>

        {/* MAIN CONTENT */}
        <div className="notes-content">

          <div className="notes-header">
            <h2>Basics of Machine Learning</h2>

            <div className="notes-icons">
              <span>✉</span>
              <span>🔍</span>
              <span>⚙</span>
            </div>
          </div>

          <h3>What is Machine Learning?</h3>

          <p>
            Machine learning is a field of artificial intelligence (AI) that
            focuses on building systems that can learn from data and improve
            their performance over time without being explicitly programmed.
            These systems analyze patterns and make predictions or decisions.
          </p>

          <h4>Examples of Machine Learning</h4>

          <div className="example-cards">

            <div className="example-card">
              📧
              <p>Email Spam Filter</p>
            </div>

            <div className="example-card">
              💳
              <p>Credit Scoring</p>
            </div>

            <div className="example-card">
              🛒
              <p>Product Recommendation</p>
            </div>

          </div>

          {/* PAGE NAV */}
          <div className="notes-footer">
            <span>⬅</span>
            <span>1 / 2</span>
            <span>➡</span>
          </div>

        </div>

        {/* RIGHT PANEL */}
        <div className="notes-right">

          <h4>🔖 Bookmarks</h4>

          <ul>
            <li>What is Machine Learning?</li>
            <li>⭐ Types of Machine Learning</li>
            <li>Supervised Learning</li>
          </ul>

        </div>

      </div>

      {/* DOWNLOAD BUTTON */}
      <button className="download-btn">⬇ Download PDF</button>

    </div>
  );
}
